import { LayoutOptions } from '~constants/view/LayoutOptions';
import { OddWidth } from '~constants/view/OddWidth';
var wideLayoutOptions = [LayoutOptions.OPTION_10, LayoutOptions.OPTION_11];
var getOddWidth = function (optionName) {
    return wideLayoutOptions.includes(optionName) ? OddWidth.L : OddWidth.M;
};
export { getOddWidth };
